import { render } from "./TabsWallet.vue?vue&type=template&id=0ba4232a"
import script from "./TabsWallet.vue?vue&type=script&lang=js"
export * from "./TabsWallet.vue?vue&type=script&lang=js"

import "./TabsWallet.vue?vue&type=style&index=0&id=0ba4232a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__